(() => {
'use strict';
function add(map,key,val){if(!key||!Number.isFinite(val))return;map.set(key,(map.get(key)||0)+val);}
function signPayload(data,index){return Number.isInteger(index)?data.signs[index]:null;}
function bodySign(result,body){
 if(result.mode==='unknown') return result.stableSigns?.[body] ?? null;
 return result.signs?.[body] ?? null;
}
function score(result){
 const data=globalThis.AsteriaBirthChartData;
 if(!data)return {ok:false,reason:'data_missing'};
 const intents=new Map(),signature=[];
 for(const body of data.bodyOrder){
  const p=data.planets[body],idx=bodySign(result,body);
  if(!p||idx==null)continue;
  const s=signPayload(data,idx);if(!s)continue;
  const w=p.weight||0;
  for(const intent of s.primary)add(intents,intent,w);
  add(intents,s.support,w*.5);
  for(const intent of p.intents)add(intents,intent,w);
  for(const intent of p.intents)if(s.primary.includes(intent))add(intents,intent,w*.5);
  if(body==='Sun'||body==='Moon')signature.push({score:4,key:body,label:body,sign:idx,house:result.houses?.[body]||null});
 }
 if(result.risingSign!=null){
  const s=signPayload(data,result.risingSign);
  for(const intent of s.primary)add(intents,intent,4);
  add(intents,s.support,2);
  signature.push({score:4,key:'Rising',label:'Rising',sign:result.risingSign,house:1});
 }
 if(result.chartRuler&&result.signs?.[result.chartRuler]!=null){
  const idx=result.signs[result.chartRuler];
  const s=signPayload(data,idx),p=data.planets[result.chartRuler];
  if(p){for(const intent of p.intents)add(intents,intent,1.5);}
  signature.push({score:3,key:'ChartRuler',label:result.chartRuler,sign:idx,house:result.houses?.[result.chartRuler]||null});
 }
 for(const a of result.angleAspects||[]){
  const bonus=a.orb<=1.5?2:a.orb<=3?1.5:1;
  signature.push({score:bonus,key:'angle:'+a.body+':'+a.point,label:a.body+'–'+a.point,angle:true,orb:a.orb});
 }
 for(const a of result.majorAspects||[]){
  const bonus=a.orb<=1.5?2:a.orb<=3?1.5:1;
  signature.push({score:bonus,key:'aspect:'+a.a+':'+a.b+':'+a.key,label:a.a+' '+a.key+' '+a.b,aspect:a});
 }
 if(result.houses){
  for(const body of ['Sun','Moon','Mercury','Venus','Mars']){
   const h=result.houses[body];
   if([1,4,7,10].includes(h))signature.push({score:(body==='Sun'||body==='Moon')?1.5:1,key:'house:'+body,label:body,sign:result.signs?.[body],house:h});
  }
 }
 const sorted=[...intents.entries()].sort((a,b)=>b[1]-a[1]).map(([intent,value])=>({intent,value}));
 const primary=sorted.slice(0,3),support=sorted[3]||null;
 const max=primary[0]?.value||1;
 const stoneScores=new Map(),stoneWhy=new Map();
 primary.forEach((entry,i)=>{
  const factor=Math.max(.55,entry.value/max);
  for(const row of data.stonesByIntent[entry.intent]||[]){
   add(stoneScores,row.stone,row.score*factor);
   (stoneWhy.get(row.stone)||stoneWhy.set(row.stone,[]).get(row.stone)).push(entry.intent);
  }
 });
 if(support){
  for(const row of data.stonesByIntent[support.intent]||[]){
   add(stoneScores,row.stone,row.score>=3?2:1);
   (stoneWhy.get(row.stone)||stoneWhy.set(row.stone,[]).get(row.stone)).push(support.intent);
  }
 }
 const stones=[...stoneScores.entries()].sort((a,b)=>b[1]-a[1]).slice(0,5).map(([stone,value])=>({stone,value,intents:[...new Set(stoneWhy.get(stone)||[])]}));
 const productScores=new Map(),productRows=new Map();
 const sourceIntents=[...primary.map(x=>x.intent),...(support?[support.intent]:[])];
 sourceIntents.forEach((intent,ii)=>{
  const intentEntry=sorted.find(x=>x.intent===intent);
  const intentFactor=ii<3?Math.max(.55,(intentEntry?.value||0)/max):.35;
  for(const row of data.productsByIntent[intent]||[]){
   const rankFactor=row.rank===1?1:row.rank===2?.78:.62;
   add(productScores,row.sku,(row.score||1)*intentFactor*rankFactor);
   if(!productRows.has(row.sku))productRows.set(row.sku,row);
  }
 });
 const products=[...productScores.entries()].sort((a,b)=>b[1]-a[1]).slice(0,6).map(([sku,value])=>({...productRows.get(sku),value}));
 const signatures=[...new Map(signature.sort((a,b)=>b.score-a.score).map(x=>[x.key,x])).values()].slice(0,3);
 return {ok:true,intents:sorted,primary,support,stones,products,signatures};
}
globalThis.AsteriaBirthChartRanking=Object.freeze({score});
})();